<script setup>
import DatePicker from 'JIX/components/DatePicker.vue';
import DsModal from 'JIX/components/ds/DsModal.vue';
import T from './JobadDateModal.i18n.js';
import { ref } from 'vue';

const JobadDateModal = ref();
const emit = defineEmits(['datesUpdated']);

const props = defineProps({
    startDate: {
        type: Number,
        required: true,
    },
    endDate: {
        type: Number,
        required: true,
    },
});

const startDate = ref(String(props.startDate));
const endDate = ref(String(props.endDate));

function updatePeriod() {
    emit('datesUpdated', { startDate: startDate.value, endDate: endDate.value });
    hide();
}

function show() {
    JobadDateModal.value.show();
}

function hide() {
    JobadDateModal.value.hide();
}

defineExpose({ show });
</script>

<template>
    <DsModal
        title="Vis for perioden"
        role="dialog"
        class-footer="btn-md-list"
        ref="JobadDateModal"
        :show="false"
    >
        <div class="row d-flex align-items-center mb-2">
            <div class="col-2">
                {{ T.start() }}
            </div>
            <DatePicker class="date-width" v-model="startDate" />
        </div>
        <div class="row d-flex align-items-center">
            <div class="col-2">
                {{ T.end() }}
            </div>
            <DatePicker class="date-width" v-model="endDate" />
        </div>
        <template #footer>
            <button
                type="button"
                class="btn btn-secondary"
                @click.prevent=""
            >
                {{ T.cancel() }}
            </button>
            <button
                type="button"
                class="btn btn-primary"
                @click.prevent="updatePeriod()"
            >
                {{ T.show() }}
            </button>
        </template>
    </DsModal>
</template>

<style scoped>
.date-width {
    width: 150px;
}
</style>
